import {styled} from '@mui/material'
import {Colors, Texts} from 'appearance'
import {useI18n} from 'store/Store'

const RequestStatus = ({value}) => {
    const {i18n} = useI18n()

    const colors = {
        create: Colors.WAITING_STATUS,
        done: Colors.APPROVED_STATUS,
        delete: Colors.DELETED_STATUS,
    }

    return (
        <Container>
            <Dot color={colors[value]} />
            <StatusText>
                {value && i18n.t(`requests.status_${value}`)}
            </StatusText>
        </Container>
    )
}

export default RequestStatus

const Container = styled('div')`
    display: flex;
    align-items: center;
    gap: 6px;
`

const Dot = styled('div')`
    background: ${({color}) => color};
    border-radius: 50px;
    height: 5px;
    width: 5px;
`

const StatusText = styled(Texts.RegularText)`
    font-size: 0.875rem;
`
